import { parse, ParsedQuery } from 'query-string';
import { useCallback } from 'react';

import { UseValidatedSearchParams } from '../interfaces/hooks';

export const useValidatedSearchParams: () => UseValidatedSearchParams = (): UseValidatedSearchParams => {
  const validateStringSearchParam: (
    searchParams: URLSearchParams, key: string, allowedValues?: string[]
  ) => string | null = useCallback((searchParams: URLSearchParams, key: string, allowedValues?: string[]): string | null => {
    try {
      const parsed: ParsedQuery<string> = parse(searchParams.toString(), { arrayFormat: 'comma' });
      const value: string | (string | null)[] | null = parsed[key];

      if (typeof value === 'string' && (!allowedValues?.length || allowedValues.includes(value))) {
        return value;
      }
    } catch {
      return null;
    }

    return null;
  }, []);

  const validateNumberSearchParam: (
    searchParams: URLSearchParams, key: string
  ) => number | null = useCallback((searchParams: URLSearchParams, key: string): number | null => {
    try {
      const parsed: ParsedQuery<string> = parse(searchParams.toString(), { arrayFormat: 'comma' });

      if (!isNaN(Number(parsed[key]))) {
        return Number(parsed[key]);
      }
    } catch {
      return null;
    }

    return null;
  }, []);

  const validateNumbersArraySearchParam: (
    searchParams: URLSearchParams, key: string
  ) => number[] | null = useCallback((searchParams: URLSearchParams, key: string): number[] | null => {
    try {
      const parsed: ParsedQuery<string> = parse(searchParams.toString(), { arrayFormat: 'comma' });
      const parsedValue: string | (string | null)[] | null = parsed[key];
      if (typeof parsedValue === 'string' && !isNaN(Number(parsedValue))) {
        return [Number(parsedValue)];
      }
      if (
        parsedValue
        && typeof parsedValue === 'object'
        && parsedValue.every((item: string | null): boolean => !isNaN(Number(item)))
      ) {
        return parsedValue.map((item: string | null): number => Number(item));
      }
    } catch {
      return null;
    }

    return null;
  }, []);

  return { validateStringSearchParam, validateNumberSearchParam, validateNumbersArraySearchParam };
};
